import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqItems = [{
    question: 'What is GreenHS VIP?',
    answer: 'Your access to daily accurate 2–5 odds tickets, delivered straight to our VIP channel!'
  }, {
    question: 'How long does my subscription last?',
    answer: 'Each subscription lasts 30 full days from activation.'
  }, {
    question: 'How do I pay?',
    answer: 'Select your region → choose your payment option → make payment → done!'
  }, {
    question: 'When will I get my predictions?',
    answer: 'Immediately after your payment is confirmed.'
  }, {
    question: 'What happens if I miss the 5-minute payment window?',
    answer: "You'll restart payment and get a new account number."
  }, {
    question: 'Can I use crypto outside Africa?',
    answer: 'Yes, select "Others" and use USDT, BTC, or ETH.'
  }, {
    question: 'Can I cancel my subscription?',
    answer: 'Subscriptions are non-refundable but can be left to expire.'
  }, {
    question: 'How do I contact support?',
    answer: 'See the Support Section below 👇'
  }];
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-white rounded-xl shadow-md p-6" data-id="element-40">
      <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-41">
        Frequently Asked Questions
      </h2>
      <div className="space-y-3" data-id="element-42">
        {faqItems.map((item, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-43">
            <button onClick={() => handleToggle(index)} className="w-full p-4 text-left flex justify-between items-center focus:outline-none" data-id="element-44">
              <span className="font-medium text-gray-800" data-id="element-45">{item.question}</span>
              {openIndex === index ? <ChevronUpIcon className="h-5 w-5 text-gray-600" data-id="element-46" /> : <ChevronDownIcon className="h-5 w-5 text-gray-600" data-id="element-47" />}
            </button>
            {openIndex === index && <div className="p-4 pt-0 text-gray-700 bg-gray-50" data-id="element-48">
                {item.answer}
              </div>}
          </div>)}
      </div>
      <div className="mt-6 p-4 bg-yellow-50 rounded-lg" data-id="element-49">
        <h3 className="font-bold text-gray-800 mb-2" data-id="element-50">Refund Policy</h3>
        <p className="text-gray-700 text-sm" data-id="element-51">
          GreenHS VIP subscriptions are non-refundable. Once payment is
          confirmed, your 30-day VIP access is guaranteed. If you face issues
          with access or payment confirmation, our support team is always
          available to assist.
        </p>
      </div>
    </section>;
}